// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oh-part-picker {\n  display: flex;\n  flex-direction: column;\n}\n.oh-part-picker .colors {\n  display: flex;\n  flex-direction: row;\n  flex: 0 auto;\n  margin-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
